// extracted by mini-css-extract-plugin
module.exports = {"root":"DemographicWidgetContainer_root__1LXzg"};